import { bunja } from 'bunja';

import { r230522SocketBunja } from './socket';

// context: https://prextech.slack.com/archives/CSJUWFLAG/p1731649392695179
export const detailBunja = bunja(() => {
  const { r230522Socket } = bunja.use(r230522SocketBunja);
  let currentPswapDetail: string | null = null;
  let currentSpotDetail: string | null = null;

  function getCurrentDetail() {
    return currentPswapDetail || currentSpotDetail;
  }

  function updateSubs() {
    r230522Socket.send({ s: { symbol: getCurrentDetail() } });
  }

  // FIXME: 땜빵을 위한 코드.. detail을 여러 심볼에 대해 구독할 수 있도록 바꾼뒤 없애야 함
  // 인자로 들어온 symbol에 대해서 구독 요청한 뒤 바로 기존 symbol의 구독으로 전환해주는 함수
  // 모달 등을 띄울 때 해당 모달에서 필요로 하는 정보를 땡겨오기 위함
  function triggerSymbolUpdate(symbol: string) {
    const current = getCurrentDetail();
    if (symbol === current) return;
    r230522Socket.send({ s: { symbol } });
    if (current) r230522Socket.send({ s: { symbol: current } });
  }

  function setCurrentPswapDetail(ticker: string | null = null) {
    currentPswapDetail = ticker;
    currentSpotDetail = null;
    updateSubs();
  }

  function setCurrentSpotDetail(ticker: string | null = null) {
    currentSpotDetail = ticker;
    currentPswapDetail = null;
    updateSubs();
  }

  bunja.effect(() => {
    updateSubs();
    r230522Socket.on('connected', updateSubs);

    return () => {
      currentPswapDetail = null;
      currentSpotDetail = null;
      updateSubs();
      r230522Socket.off('connected', updateSubs);
    };
  });

  return {
    triggerSymbolUpdate,
    setCurrentPswapDetail,
    setCurrentSpotDetail,
  };
});
detailBunja.debugLabel = 'detailBunja';
